<template>
  <list-table
    :url="url"
    title="احراز هویت"
    :detailUrl="detailUrl"
    :fields="fields"
    :params="params"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import TableShowData from "../../components/table";
export default {
  name: "Authentication",
  data() {
    return {
      url: "authentication",
      params: [
        {
          label: "نام پذیرنده",
          field: "name",
          type: "text",
        },
        {
          label: "شماره همراه",
          field: "mobile",
          type: "text",
        },
        {
          label: "ایمیل",
          field: "email",
          type: "text",
        },
        {
          label: "وضعیت",
          field: "status",
          type: "select",
          options: [
            { text: "تایید نشده", value: 3 },
            { text: "بررسی نشده", value: 1 },
            { text: "تایید شد", value: 2 },
          ],
        },
      ],
      fields: [
        {
          key: "name",
          label: "نام پدیرنده",
        },
        {
          key: "mobile",
          label: "شماره همراه",
        },
        {
          key: "email",
          label: "پست الکترونیکی",
        },
        {
          key: "national_card_number",
          label: "کد ملی",
        },
        {
          key: "type",
          label: "نوع احراز",
        },
        {
          key: "shaba_number",
          label: "شماره شبا",
        },
        {
          key: "status",
          label: "وضعیت",
          formatter: (value, key, item) => {
            switch (item.status) {
              case "0":
                return "تایید نشده";
                break;
              case "2":
                return "تایید شده";
                break;
              default:
                return "بررسی نشده";
            }
          },
          tdClass: (value, key, item) => {
            switch (item.status) {
              case "0":
                return "text-danger";
                break;
              case "2":
                return "text-success";
                break;
              default:
                return "text-warning";
            }
          },
        },
        {
          key: "details",
          label: "عملیات",
        },
      ],
      detailUrl: "editUserConf",
    };
  },
  components: {
    "list-table": TableShowData,
  },
  methods: {},
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "احراز هویت" }]);
  },
};
</script>